import React from 'react';

export default function About() {
	return (
		<section id="about">
			<div className="container mx-auto flex px-10 py-20 md:flex-row flex-col items-center">
				<div className="lg:flex-grow md:w-1/2 lg:pr-24 md:pr-16 flex flex-col md:items-start md:text-left mb-16 md:mb-0 items-center text-center">
					<h1 className="title-font sm:text-4xl text-3xl mb-4 font-medium text-white">
						Hi, I'm Christina Delancy.
						<br className="hidden lg:inline-block sm:inline-block"/> I love to
						build amazing apps.
					</h1>
					<p className="mb-8 leading-relaxed">
						I have always been fascinated by technology and the healthcare
						industry and thought that Medical Coding was a perfect combination
						of the two. I was halfway done with my medical coding certification
						and taking a course on Telemedicine. I was taught how essential it
						was during the pandemic but also how it is so very behind the rest
						of the technological advances we have in other industries because of
						a lack of implementation and know-how. I want to make it easier for
						all people to have access to the medical help they need. <br />
						<br />
						I finished my certification and heard about the Future Code program
						with FullStack Academy, and a light bulb went off that this would be
						the most hands-on way of achieving my goals. I am looking forward to
						utilizing my skills as a software developer to help many different
						communities. <br />
						<br />
						Further in my career, I want to implement an Electronic Health
						Records Software that makes interoperability so easy between small
						clinics and major hospitals, that makes it easy to have a virtual
						visit with your doctor and gives patients access to their health
						records at the touch of their fingertip.
					</p>
					<div className="flex justify-center">
						<a
							href="#contact"
							className="inline-flex text-white bg-red-500 border-0 py-2 px-6 focus:outline-none hover:bg-red-600 rounded text-lg text-center"
						>
							Contact Me
						</a>
						<a
							href="#projects"
							className="ml-4 inline-flex text-gray-400 bg-zinc-800 border-0 py-2 px-6 focus:outline-none hover:bg-zinc-700 hover:text-white rounded text-lg text-center"
						>
							See My Past Work
						</a>
					</div>
					<div className="flex flex-row content-center mt-4">
						<h5 className="title-font sm:text-2xl text-xl mb-4 font-medium text-white text-base pt-4 mt-4 align-middle">
							Follow Me On:
						</h5>
						<a
							className="w-20 h-20 m-4 border-4 bg-white hover:border-red-800"
							href="https://github.com/CDelancy19"
							target="_blank"
						>
							<img src="/Github-Mark.png" alt="Link to Github" />
						</a>
						<a
							className="w-20 h-20 m-4 border-4 bg-white hover:border-red-800"
							href="https://www.linkedin.com/in/cdelancy11/"
							target="_blank"
						>
							<img src="/LinkedIn-Mark.png" alt="Link to LinkedIn" />
						</a>
					</div>
				</div>
				<div className="lg:max-w-lg lg:w-full md:w-1/2 w-5/6 bg-white">
					<img
						className="object-cover object-center rounded"
						alt="hero"
						src="./coding.svg"
					/>
				</div>
			</div>
		</section>
	);
}



// WEBPACK FOOTER //
// ./src/components/About.js